<template>
	<div class="welcome">
		<div class="con">
			<img src="../../assets/img/welcomeLogo.png" alt="" width="88">
			<h2>心理咨询后台管理</h2>
			<p>欢迎回来 !</p>
			<p>Welcome  Back ! </p>
			<div class="flex">
				<el-button v-for="item in navBars" :key="item.title" @click="goToLink(item.path)">{{item.title}}</el-button>
			</div>
		</div>


	</div>
</template>

<script>
export default {
    name: "welcome",
	data(){
        return{
            navBars: [],
		}
	},
	mounted() {
        // 从侧边获取前4个菜单展示
        let that = this;
        let count = 0;
        let timer = setInterval(_=>{
            if(count > 10){
                clearInterval(timer);
            }
            that.getParentPath(timer);
            count++;
		},1000);
    },
	methods:{
        goToLink(path){
            this.$router.push({path: path});
		},
		getParentPath(timer){
            let navs = this.$router.app.$children[0].$children[0].navBars;
            if(navs && navs.length>0){
                clearInterval(timer);
                let size = navs.length;
                if(size<=4){
                    this.navBars.push(...navs);
                }else{
                    this.navBars.push(navs[0]);
                    this.navBars.push(navs[1]);
                    this.navBars.push(navs[2]);
                    this.navBars.push(navs[3]);
                }
            }
		},

	}
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/welcome";

</style>